import type { AppointmentStatus } from "@/features/appointment/types";

export const APPOINTMENT_STATUSES: readonly AppointmentStatus[] = [
  "SCHEDULED",
  "COMPLETED",
  "CANCELED",
  "NO_SHOW",
] as const;

export const APPOINTMENT_STATUS_LABELS: Record<AppointmentStatus, string> = {
  PENDING_SOURCE: "Chờ nguồn",
  PENDING_AGENT: "Chờ khách",
  SCHEDULED: "Đã lên lịch",
  COMPLETED: "Đã hoàn thành",
  CANCELED: "Đã hủy",
  NO_SHOW: "Không đến",
};

/** Soft-tone class strings for badges, aligned with the Estate design. */
export const APPOINTMENT_STATUS_COLORS: Record<AppointmentStatus, string> = {
  PENDING_SOURCE: "border-transparent bg-amber-100 text-amber-700",
  PENDING_AGENT: "border-transparent bg-violet-100 text-violet-700",
  SCHEDULED: "border-transparent bg-blue-100 text-blue-700",
  COMPLETED: "border-transparent bg-emerald-100 text-emerald-700",
  CANCELED: "border-transparent bg-zinc-100 text-zinc-600",
  NO_SHOW: "border-transparent bg-slate-100 text-slate-600",
};

/** Sentinel value for "no filter" in the broker / status Select. */
export const ALL_VALUE = "__ALL__";
